module.exports = __webpack_public_path__ + "img/icons8-ruler.12709137.svg";